import styled from 'styled-components'

const LinkBtn = styled.a`
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #4aac8b;
  cursor: pointer;
`

export default LinkBtn
